import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { selectAppSessionId } from 'store/session/selectors';

import { PrivacyPolicyUavParams, UavEvents } from 'services/uav/types';

import useGetBaseUavParams from './useGetBaseUavParams';

function usePrivacyPolicyParams() {
    const appSessionId = useSelector(selectAppSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getPrivacyPolicyUavParams = useCallback(
        (consents: string): PrivacyPolicyUavParams | undefined => {
            const baseUavParams = getBaseUavParams(UavEvents.PRIVACY_POLICY);

            if (baseUavParams && appSessionId) {
                return {
                    ...baseUavParams,
                    metadata: {
                        policyType: 'GDPR',
                        consentProvider: 'Didomi',
                        consents,
                        ...baseUavParams.metadata,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId],
    );

    return {
        getPrivacyPolicyUavParams,
    };
}

export default usePrivacyPolicyParams;
